import { render, staticRenderFns } from "./Entry_button.vue?vue&type=template&id=52038b95"
import script from "./Entry_button.vue?vue&type=script&lang=js"
export * from "./Entry_button.vue?vue&type=script&lang=js"
import style0 from "./Entry_button.vue?vue&type=style&index=0&id=52038b95&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports